import React from 'react';
import { motion } from 'framer-motion';

const WorkProcess = () => {
  const steps = [
    {
      title: "Understand your organisation",
      desc: "We explore how AI is already being used, what is working, and where the specific challenges are for your mission and community."
    },
    {
      title: "Create clarity",
      desc: "Together we identify priorities, essential leadership decisions, and practical next steps that move you from uncertainty to action."
    },
    {
      title: "Build confidence",
      desc: "We implement practical systems, guidance, and capability that help your organisation use AI consistently and responsibly."
    }
  ];

  return (
    <div className="mt-24 py-16 border-t border-gray-100">
      <h2 className="text-3xl font-bold text-brand-navy mb-12 text-center">How we work together</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {steps.map((step, i) => (
          <motion.div 
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="text-6xl font-black text-brand-teal/10 absolute -top-10 -left-2 select-none">{i + 1}</div>
            <div className="relative z-10">
              <h3 className="text-xl font-bold text-brand-navy mb-4">{step.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">{step.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default WorkProcess;